// src/constants/tabs.js

export const TABS = Object.freeze({
  FEED: "feed",
  MOMENT: "moment",
  CHATS: "chats",
  CONNECT: "connect",

  MY_POSTS: "my_posts",
    MY_MEDIA_POSTS: "my_media_posts", 
  INTERACTIONS: "interactions",
  NOTIFICATIONS: "notifications",

  P2P: "p2p",
  ASSETS: "assets",

  SEND: "send",
  TRANSACTIONS: "transactions",

   SETTINGS: "settings",
  ABOUT: "about",
  HELP: "help",
  BUY_DATA: "buy_data",
});

/**
 * Tabs that should show the MOBILE bottom navigation.
 */
export const MOBILE_PRIMARY_TABS = Object.freeze([
  TABS.FEED,
  TABS.CHATS,
  TABS.MOMENT,
  TABS.ASSETS,
  TABS.P2P,
]);

export const DEFAULT_TAB = TABS.CHATS;